import React, { useState } from 'react';
import { AsyncDataPlaceholder, Button } from '../../../ui';

export const PageLoader = () => {
	const [isLoading, setIsLoading] = useState(false);

	const toggleLoader = () => {
		setIsLoading((state) => !state);
	};

	return (
		<>
			<h2 id="loading-indicator">Loading indicator</h2>
			{isLoading && <AsyncDataPlaceholder />}
			<Button onClick={toggleLoader}>
				{isLoading ? 'Stop loading' : 'Start loading'}
			</Button>
		</>
	);
};
